var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pt-2"},[_vm._v(" "+_vm._s(_vm.$t('errors.collegiate_not_allow_to_prescribe'))+" "),_c('div',{staticClass:"actions"},[_c('v-btn',{staticClass:"white--text",attrs:{"color":"primary","depressed":""},on:{"click":_vm.goToProfile}},[_vm._v(" "+_vm._s(_vm.$t('common.go_to_profile'))+" ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }